import {
  createStore,
  DEFAULT_PAGE_META,
  type PageMeta,
  type ReadOnlyStore,
} from "@observe-tech/mfe-shell-api";

export interface PageMetaApi {
  meta: ReadOnlyStore<PageMeta>;
  set(m: Partial<PageMeta>): void;
  clear(): void;
}

export function createPageMetaApi(): PageMetaApi {
  const store = createStore<PageMeta>(DEFAULT_PAGE_META);
  return {
    meta: store.store,
    set: (m) => store.set({ ...store.store.get(), ...m }),
    clear: () => store.set(DEFAULT_PAGE_META),
  };
}
